import createAxiosInstance from '../support/AxiosSupport';

/** Ключ API (Personal API Token) — секрет хранится только у пользователя. */
export interface ApiTokenInfo {
    id: string;
    name: string;
    prefix: string;
    scopes: string[];
    adminToken: boolean;
    expiresAt: string | null;
    lastUsedAt: string | null;
    revokedAt: string | null;
    createdAt: string;
    active: boolean;
    status: 'active' | 'expired' | 'revoked';
}

export interface ApiTokenCreated {
    /** Секрет ключа — показывается ровно один раз. */
    token: string;
    tokenInfo: ApiTokenInfo;
}

export interface CreateApiTokenRequest {
    name: string;
    scopes: string[];
    expiresAt: string | null;
}

/**
 * Скоупы публичного API, доступные для выпуска ключа в кабинете (v1).
 * Скоуп `admin` и зарезервированные (`outfits:*`, `analytics:read`,
 * `ai:recognize`) в UI не предлагаются.
 */
export const PUBLIC_API_SCOPES: Array<{ scope: string; label: string; description: string }> = [
    {scope: 'profile:read', label: 'Профиль', description: 'Чтение профиля ключа и доступных гардеробов'},
    {scope: 'wardrobe:read', label: 'Гардероб: чтение', description: 'Вещи, статистика, история носки, изображения, справочники'},
    {scope: 'wardrobe:write', label: 'Гардероб: изменение', description: 'Создание и изменение вещей, носка/стирка, решения о выбытии, загрузка фото'},
    {scope: 'lists:read', label: 'Списки: чтение', description: 'Просмотр списков и их содержимого'},
    {scope: 'lists:write', label: 'Списки: изменение', description: 'Создание списков, добавление и удаление вещей'},
];

export async function fetchApiTokens(): Promise<ApiTokenInfo[]> {
    const api = await createAxiosInstance();
    const res = await api.get<ApiTokenInfo[]>('/tokens');
    return res.data ?? [];
}

export async function createApiToken(request: CreateApiTokenRequest): Promise<ApiTokenCreated> {
    const api = await createAxiosInstance();
    const res = await api.post<ApiTokenCreated>('/tokens', request);
    return res.data;
}

export async function revokeApiToken(id: string): Promise<void> {
    const api = await createAxiosInstance();
    await api.delete(`/tokens/${id}`);
}
